<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d5vxLe/tc-custom/9780830846801.jpg?1696024616032" alt="This image is the cover for the book Prayer in the Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prayer in the Night
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>ECPA Christian Book of the Year<br/> <em>Christianity Today</em> Book of the Year<br/> <em>Foreword</em> INDIES Book of the Year Award Finalist<br/> IVP Readers' Choice Award</strong> </p> <p> <strong>How can we trust God in the dark?</strong> </p> <p>Framed around a nighttime prayer of Compline, Tish Harrison Warren, author of <em>Liturgy of the Ordinary</em>, explores themes of human vulnerability, suffering, and God's seeming absence. When she navigated a time of doubt and loss, the prayer was grounding for her. She writes that practices of prayer "gave words to my anxiety and grief and allowed me to reencounter the doctrines of the church not as tidy little antidotes for pain, but as a light in darkness, as good news."</p> <p>Where do we find comfort when we lie awake worrying or weeping in the night? This book offers a prayerful and frank approach to the difficulties in our ordinary lives at work, at home, and in a world filled with uncertainty.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tish Harrison Warren
      </h2>
      
      <p class="authorDescription body article"><p>Tish Harrison Warren is the author of <em>Liturgy of the Ordinary</em>, which was <em>Christianity Today's</em> 2018 Book of the Year. She is a weekly contributing newsletter writer for the <em>New York Times</em> and writes a monthly column for <em>Christianity Today</em>. She has worked in ministry settings for over a decade as a campus minister with InterVarsity Graduate and Faculty Ministries and as the writer-in-residence at Church of the Ascension in Pittsburgh, Pennsylvania. Her articles and essays have appeared in the <em>New York Times</em>, Religion News Service, <em>Christianity Today</em>, <em>Comment Magazine</em>, <em>The Point</em>, and elsewhere.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c64a027